import App from './App.svelte';
import expenses from './expenses';

const app = new App({
	target: document.body,
	props: {
		
	}
});

export default app;
